import {
  ApolloClient,
  ApolloLink,
  HttpLink,
  InMemoryCache,
} from "@apollo/client";
import { envConfig } from "../utils/constants";
import { onError } from "@apollo/client/link/error";
import { addDataLayer } from "../utils/utility";

// Log any GraphQL errors or network error that occurred
const errorLink = onError(({ graphQLErrors }) => {
  if (graphQLErrors)
    graphQLErrors.forEach(({ message, locations, path }) => {
      const msg = `[GraphQL error]: Message: ${message}, Location: ${locations}, Path: ${path}`;
      addDataLayer({ error: msg }, "dlv_track_error");
    });
  // if (networkError) console.log(`[Network error]: ${networkError}`);
});

export const client = new ApolloClient({
  link: ApolloLink.from([
    errorLink,
    new HttpLink({ uri: envConfig.grpahqlEndpoint }),
  ]),
  cache: new InMemoryCache(),
});
